export default {
	section_banner: {
		title: {
			one: '支払い',
			two: 'で',
			three: 'ワンテザー',
		},
		subtitle: {
			one: '迅速＆',
			two: '安全な',
			three: '決済',
		},
		cta_buttons: {
			one: '始める',
			two: 'アプリをダウンロード',
		},
	},
	section_question: {
		label: 'よくある質問',
		title: {
			one: 'いつでも',
			two: '安全な',
			three: '決済',
		},
		description:
			'ワンテザーのセキュリティは世界最高水準です。お客様の暗号資産やデジタル資産を完全に安全に保管し、安心してご利用いただけます。',
		cta_button: '始める',
	},
	section_we_offer: {
		label: 'ワンテザーウォレット',
		title: {
			one: 'どこでも',
			two: 'ショッピングを',
			three: '楽しむ',
		},
		description:
			'ワンテザーウォレットに保管された暗号資産で、いつでもどこでもシームレスで安全な取引が可能です。オンラインショッピングでも実店舗での支払いでも、ブロックチェーン技術を活用したワンテザーが迅速で確実な決済を実現します。',
		enjoy_shopping: {
			title: 'どこでもショッピングを楽しむ',
			subtitle: 'ワンテザーウォレットに保管された暗号資産で',
			boxes: {
				one: {
					title: '理想的な暗号資産ウォレット',
					description: 'ワンテザーで希望する暗号資産ウォレットを作成できます。',
				},
				two: {
					title: 'スマートなショッピング',
					description: 'お買い物の際はワンテザーをご利用ください。',
				},
				three: {
					title: '私たちで支払う',
					description: 'ワンテザーで希望する暗号資産で支払いができます。',
				},
			},
			cta_button: '無料アカウントを作成',
		},
	},
	section_online_mid: {
		label: '最速の決済システム',
		title: {
			one: 'また',
			two: '楽しんで',
			three: 'いただけます',
		},
		description:
			'ワンテザーでのお買い物で、次回の購入に使えるポイントが貯まります。ワンテザーポイントは、ワンテザーを利用する全ての加盟店でご利用いただけ、お買い物とポイント獲得が簡単に行えます。シームレスな取引で、お買い物ごとにお得な特典が受けられます。さらに、ワンテザーユーザー限定の特別オファーや割引もお楽しみいただけます。',
		cta_button: '始める',
	},
	section_growth: {
		stats: {
			total_customers: {
				value: '80万',
				label: '総顧客数',
			},
			customer_satisfaction: {
				value: '99.90%',
				label: '顧客満足度',
			},
			money_managed: {
				value: '2,600億',
				label: '運用資産',
			},
		},
	},
	section_newsletter: {
		label: 'ニュースレター購読',
		title: {
			one: '購読して',
			two: '最新情報を入手',
		},
		description: {
			one: '購読すると、オファーや最新情報を直接受け取れます。',
			two: 'ワンテザーソリューションがあなたのビジネスをどのように成長させるか、お問い合わせください。',
		},
		form: {
			placeholder: 'メールアドレス',
			button: '今すぐ購読',
		},
	},
};
